import React, { useEffect, useState } from "react";
import lang from "../../assets/lang.png";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Popover,
  Select,
  Switch,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import dayjs from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import clock from "../../assets/clock.png";
import {
  FetchWidgetConfigDetails,
  GetOpeningHours,
  getLanguageDetails,
} from "../../api/HorecaWidget.service";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  SetUpateOpeningHours,
  setLanguageID,
  setLanguageWords,
  updateDefaultLanguage,
} from "../../store/slice/Addguest.slice";
import LanguageMenuItem from "../../components/SelectComponent/LanguageMenuItem";
import {
  setLanguageLoaded,
  updateLanguageData,
  updateWidgetConfig,
  updateWidgetUrl,
} from "../../store/slice/widgetSetting.slice";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const OpeningHours = ({ resType }) => {
  const apiUrl =
    resType == "horecaopeninghours"
      ? "GetHorecaOpeningsHours"
      : resType == "activityopeninghours"
      ? "GetActivitiesOpeningsHours"
      : resType == "ticketingopeninghours"
      ? "GetTicketingOpeningsHours"
      : resType == "salonopeninghours"
      ? "GetSalonOpeningsHours"
      : "GetWebshopOpeningsHours";
  const { widgetConfig, key } = useSelector((store) => store?.widgetSettings);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const widgetSetupId = queryParams.get("widgetsetupid");
  const { OpeningHoursWidget, defaultLanguage, languageWords } = useSelector(
    (store) => store?.addGuest
  );
  const { languageData } = useSelector((store) => store?.widgetSettings);
  const { widgetUrl } = useSelector((store) => store?.widgetSettings);
  const [langLoading, setLangLoading] = useState(false);
  const [loadingOpeningHours, setLoadingOpeningHours] = useState(false);
  const dispatch = useDispatch();
  const theme = useTheme();

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); // For xs and sm
  const isMediumOrLargeScreen = useMediaQuery(theme.breakpoints.up("md")); // For md and lg
  const [selectedYear, setSelectedYear] = useState(dayjs().year());
  const [selectedMonth, setSelectedMonth] = useState(dayjs().month()); // Initial current month
  const [selectedDate, setSelectedDate] = useState({
    year: dayjs().year(),
    month: dayjs().month(),
    day: null,
  }); // Selected date
  const currentYear = dayjs().year();
  const currentMonth = dayjs().month(); // 0-based

  const [showMoreMonths, setShowMoreMonths] = useState(true);

  const optionData = [
    {
      label: "One Month",
      value: 1,
    },
    {
      label: "Three Months",
      value: 3,
    },
    {
      label: "Six Months",
      value: 6,
    },
    {
      label: "One Year",
      value: 12,
    },
  ];
  const [option, setOption] = useState(optionData[1].value); // store number only
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const label = { inputProps: { "aria-label": "Show More Months" } };

  // TEMP fix
  const dayKeys = [
    "monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const monthKeys = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const months = monthKeys?.map((key) => languageWords && languageWords[key]);

  const daysOfWeek = dayKeys?.map(
    (key) => languageWords && languageWords[key]?.slice(0, 2)
  );

  const [selectedOpeningHours, seSelecteOpeningHours] = useState({});
  const [widgetLoading, setWidgetLoading] = useState(false);

  // TEMP fix
  //const months = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"];

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // get the height of the widget
  const getHeight = () => {
    setTimeout(() => {
      let rootHeight = document.getElementsByClassName("MuiBox-root")[1];
      let frameHeight = 200;
      if (rootHeight) {
        if (rootHeight.clientHeight > frameHeight) {
          if (rootHeight.clientWidth < 700) {
            frameHeight = rootHeight.clientHeight + 100;
          } else {
            frameHeight = rootHeight.clientHeight + 20;
          }
        }

        if (frameHeight < 480) {
          frameHeight = 480;
        }
      }
      send(
        frameHeight + "px",
        "100%",
        "",
        "0px",
        "0px",
        "",
        widgetConfig?.settings?.floatButtonActive
      );
    }, 100);
  };

  // get the height of the MuiBox-root after loading the full page
  useEffect(() => {
    getHeight();
  });
  // Function to get number of days in the current month
  const daysInMonth = (monthIndex, year) => {
    return dayjs(`${year}-${monthIndex + 1}-01`).daysInMonth();
  };
  // Handlers for changing the month and year
  const handlePreviousMonth = () => {
    if (selectedMonth === 0) {
      setSelectedMonth(11);
      setSelectedYear(selectedYear - 1);
    } else {
      setSelectedMonth(selectedMonth - 1);
    }
  };

  const handleNextMonth = () => {
    if (selectedMonth === 11) {
      setSelectedMonth(0);
      setSelectedYear(selectedYear + 1);
    } else {
      setSelectedMonth(selectedMonth + 1);
    }
  };

  const send = (
    frameHeight,
    frameWidth,
    top,
    right,
    bottom,
    left,
    floating,
    redirectUrl
  ) => {
    window.parent.postMessage(
      {
        reservationIframeHeight: frameHeight,
        reservationIframeWidth: frameWidth,
        reservationIframePositionTop: top,
        reservationIframePositionRight: right,
        reservationIframePositionBottom: bottom,
        reservationIframePositionLeft: left,
        reservationIframePositionFloating: floating,
        redirectUrl: redirectUrl,
      },
      "*"
    );
  };
  const handleDateClick = (day, monthIndex, year) => {
    setSelectedDate({ year, month: monthIndex, day });
    // Format the date string correctly, ensuring monthIndex is incremented
    const formattedMonth = monthIndex; // JavaScript months are 0-indexed
    const formattedMonthStr =
      formattedMonth <= 9 ? `0${formattedMonth}` : formattedMonth;
    const formattedDay = day <= 9 ? `0${day}` : day;
    const selectDate = `${year}-${formattedMonthStr}-${formattedDay}`;
    // Filter the opening hours for the selected date
    const indviudualOpeningHours = OpeningHoursWidget?.filter(
      (item) => dayjs(item?.openingDate).format("YYYY-MM-DD") === selectDate
    );
    seSelecteOpeningHours(indviudualOpeningHours);
  };

  const getDayWithSuffix = (day) => {
    if (day > 3 && day < 21) return `${day}th`; // For 11th to 20th
    switch (day % 10) {
      case 1:
        return `${day}st`;
      case 2:
        return `${day}nd`;
      case 3:
        return `${day}rd`;
      default:
        return `${day}th`;
    }
  };

  const formatDate = ({ year = "", month = "", day = "" }) => {
    const date = dayjs(`${year}-${month}-${day}`) ?? "";
    const dayWithSuffix = getDayWithSuffix(day);
    const formattedMonth = date.format("MMMM");
    return `${dayWithSuffix} ${languageWords[`${formattedMonth}`]} ${year}`;
    // return `${day} ${months[month]} ${year}`;
  };

  const renderCalendar = (monthIndex, year) => {
    // Helper function to format date as 'YYYY-MM-DD' for matching
    const formatDateForComparison = (day) => {
      return `${year}-${(monthIndex + 1).toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;
    };

    // Get the day of the week the first day of the month falls on (adjusted so Monday is the first day)
    let firstDayOfMonth = new Date(year, monthIndex, 1).getDay();
    firstDayOfMonth = firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1; // Adjust so Monday is 0, Sunday is 6

    // Calculate the number of days in the month
    const totalDaysInMonth = daysInMonth(monthIndex, year);

    return (
      <Box
        sx={{
          width: { md: "100%", sm: "100%" },
          minHeight: "450px",
          border: "1px solid #EBEBEB",
          padding: isMediumOrLargeScreen ? "1.5rem" : "16px",
          borderRadius: "8px",
          marginBottom: 2,
          backgroundColor: "#F7F8F0",
          // theme?.openingHours?.calendarBackgroundColor,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            marginBottom: 1,
            color: theme?.openingHours?.monthTextColor,
            fontSize: "20px",
            fontWeight: "medium",
          }}
        >
          {months[monthIndex]} {year}
        </Typography>

        {/* Days of the Week Row */}
        <Grid container spacing={3}>
          {daysOfWeek?.map((day, index) => (
            <Grid item xs={1.71} md={1.71} key={index}>
              <Typography
                sx={{
                  textAlign: "center",
                  fontWeight: "medium",
                  color: "grey",
                  //        theme?.openingHours?.dayTextColor, // Optional color for day labels
                  fontSize: "16px",
                }}
              >
                {day}
              </Typography>
            </Grid>
          ))}
        </Grid>

        {/* Dates Grid */}
        <Grid container spacing={3} sx={{ marginTop: 1 }}>
          {/* Add empty grid items to align the first day of the month */}
          {Array.from({ length: firstDayOfMonth }).map((_, index) => (
            <Grid item xs={1.71} md={1.71} key={`empty-${index}`} />
          ))}

          {/* Render the actual days of the month */}
          {Array.from({ length: totalDaysInMonth }, (_, day) => {
            const formattedDate = formatDateForComparison(day + 1);
            const isOpeningDate = OpeningHoursWidget?.some(
              (item) =>
                dayjs(item.openingDate).format("YYYY-MM-DD") == formattedDate
            );
            const currentDate = new Date();
            const isPast =
              new Date(year, monthIndex, day + 1) <
              new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate()
              );
            const dayStyles = isOpeningDate
              ? {
                  backgroundColor: "#FFF4E6", // very soft orange tint
                  color: "grey", // deep warm orange text
                  border: "1px solid #FDBA74", // soft orange border
                  cursor: "pointer",
                  fontWeight: 600,
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "#FFE8CC",
                    transform: "translateY(-2px)",
                    //     boxShadow: "0 6px 18px rgba(251,146,60,0.25)",
                  },
                }
              : {
                  backgroundColor: "#F9FAFB", // clean neutral
                  color: "#9CA3AF",
                  border: "1px solid #E5E7EB",
                  cursor: "not-allowed",
                  opacity: 0.85,
                };

            return (
              <Grid item xs={1.71} md={1.71} key={day}>
                <Box
                  onClick={(event) => {
                    if (!isOpeningDate || isPast) {
                      return;
                    }
                    setAnchorEl(event.currentTarget);
                    handleDateClick(day + 1, monthIndex + 1, year);
                  }} // `day + 1` for 1-based days
                  sx={{
                    width: 30,
                    height: 30,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "auto",
                    ...dayStyles,
                    borderRadius: "4px",
                  }}
                >
                  {day + 1}
                </Box>
              </Grid>
            );
          })}
        </Grid>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          PaperProps={{
            sx: {
              elevation: 0,
              borderRadius: "12px",
              backgroundColor: "#ffffff",
            },
          }}
        >
          <Box
            sx={{
              width: isSmallScreen ? "92vw" : "340px",
              p: 3,
            }}
          >
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#1f2937",
                }}
              >
                {formatDate(selectedDate)}
              </Typography>

              <IconButton
                onClick={handleClose}
                size="small"
                sx={{
                  width: 30,
                  height: 30,
                  color: "#6b7280",
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>

            {/* Time Section */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 2,
                mb: 3,
              }}
            >
              {/* Open From */}
              <Box>
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "#6b7280",
                    mb: 0.5,
                  }}
                >
                  {languageWords?.OpenFrom}
                </Typography>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <AccessTimeIcon sx={{ fontSize: 16, color: "#9ca3af" }} />
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#111827",
                    }}
                  >
                    {selectedOpeningHours[0]?.openTime?.slice(0, 5)}
                  </Typography>
                </Box>
              </Box>

              {/* Open To */}
              <Box>
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "#6b7280",
                    mb: 0.5,
                  }}
                >
                  {languageWords?.OpenTo}
                </Typography>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <AccessTimeIcon sx={{ fontSize: 16, color: "#9ca3af" }} />
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#111827",
                    }}
                  >
                    {selectedOpeningHours[0]?.closeTime?.slice(0, 5)}
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Button */}
            <Button
              fullWidth
              variant="contained"
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 500,
                fontSize: "14px",
                backgroundColor: "#f97316",
                "&:hover": {
                  backgroundColor: "#ea580c",
                },
              }}
              onClick={() => {
                window.location.href = widgetUrl;
              }}
            >
              {languageWords?.BookingResservationBtnText}
            </Button>
          </Box>
        </Popover>
      </Box>
    );
  };

  const getMaxOpeningDate = (openingHoursWidget = []) => {
    const latestOpeningDate = openingHoursWidget
      ?.map((widget) => dayjs(widget.openingDate))
      .reduce(
        (maxDate, currentDate) =>
          currentDate.isAfter(maxDate) ? currentDate : maxDate,
        dayjs(0)
      ); // Start with the earliest date

    return { month: latestOpeningDate.month(), year: latestOpeningDate.year() }; // month() returns 0-based index
  };
  const { month: maxMonth, year: maxYear } =
    getMaxOpeningDate(OpeningHoursWidget);
  const isForwardButtonDisabled =
    selectedYear > maxYear ||
    (selectedYear === maxYear && selectedMonth >= maxMonth);

  const monthsToShow = isSmallScreen
    ? [{ month: selectedMonth, year: selectedYear }]
    : [
        { month: selectedMonth, year: selectedYear },
        {
          month: (selectedMonth + 1) % 12, // Move to the next month
          year: selectedMonth === 11 ? selectedYear + 1 : selectedYear, // Handle year transition when moving from December
        },
        {
          month: (selectedMonth + 2) % 12, // Move to the month after next
          year: selectedMonth >= 10 ? selectedYear + 1 : selectedYear, // Handle year transition for November and December
        },
      ];

  const fetchOpeningHours = async () => {
    setError(false);
    setLoadingOpeningHours(true);
    try {
      const response = await GetOpeningHours(key, defaultLanguage, apiUrl);

      const result = response?.basicLanguages?.reduce((acc, item) => {
        const tag = item.tag.replace(/{|}/g, "").replace(/\s+/g, "");
        const data = item.widgetTranslateLanguages[0]?.name;
        acc[tag] = data; // Assign data to the key acc[tag]
        return acc;
      }, {});
      dispatch(setLanguageWords(result));
      dispatch(SetUpateOpeningHours(response?.openingHours));
      dispatch(updateWidgetUrl(response?.widgetUrl));
      setLoadingOpeningHours(false);
    } catch (error) {
      setLoadingOpeningHours(false);
    }
  };
  const fetchLanguageDetails = async () => {
    setLangLoading(true);
    try {
      const response = await getLanguageDetails(key);
      if (response?.status != 200) {
        console.error("Error fetching language details widget:", response);
        return;
      }
      dispatch(updateLanguageData(response?.data));
      const langParam = queryParams.get("lang");
      if (response?.data) {
        const defaultLang =
          !defaultLanguage && !langParam
            ? response?.data?.find((item) => item?.defaultLanguage)?.langcode
            : langParam
            ? langParam
            : defaultLanguage;

        dispatch(updateDefaultLanguage(defaultLang));
        dispatch(setLanguageLoaded(true)); // Set the flag to true
        dispatch(setLanguageID(defaultLang?.idlanguage));
      }
      setLangLoading(false);
    } catch (error) {
      console.error("Error fetching language details widget:", error?.message);
      setLangLoading(false);
    }
  };

  const fetchWidgetSettingsDetails = async (lang) => {
    try {
      setWidgetLoading(true);
      const response = await FetchWidgetConfigDetails(key, widgetSetupId, lang);
      if (response?.status != 200 || !response?.data) {
        throw new Error(
          "Failed to fetch widget settings details. Please try again later."
        );
      }

      dispatch(updateWidgetConfig(response?.data));
      setWidgetLoading(false);
    } catch (error) {
      console.error("Error fetching widget settings details:", error);
      setWidgetLoading(false);
    }
  };
  const handleLanguageChange = (event) => {
    const selectedLangCode = event.target.value;
    const selectedLanguage = languageData?.find(
      (item) => item.langcode === selectedLangCode
    );
    dispatch(updateDefaultLanguage(selectedLanguage?.langcode));
    dispatch(setLanguageID(selectedLanguage?.idlanguage));
  };

  useEffect(() => {
    fetchWidgetSettingsDetails(defaultLanguage);
  }, []);

  useEffect(() => {
    if (defaultLanguage) fetchOpeningHours();
  }, [defaultLanguage]);
  useEffect(() => {
    fetchLanguageDetails();
  }, []);

  if (loadingOpeningHours || langLoading) {
    return (
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loadingOpeningHours}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }
  if (error)
    return (
      <Box
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          mt: 3,
          color: "red",
          fontSize: "1.2rem",
        }}
      >
        something went wrong !
      </Box>
    );

  return (
    <Box
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Paper
        elevation={1}
        sx={{
          backgroundColor: theme?.openingHours?.backgroundColor,
          width: "100%",
          minHeight: "100vh",
          height: "auto",
        }}
      >
        <Box sx={{ textAlign: "center", padding: "16px" }}>
          {/* Heading */}
          <Typography
            sx={{
              marginBottom: 2,
              fontSize: "24px",
              fontWeight: "medium",
              color: theme?.openingHours?.headerTextColor,
            }}
          >
            {languageWords?.OpeninghrsCalender}
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            {languageData?.length > 1 && (
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  //    mr: isSmallScreen || isMediumScreen ? "1rem" : "12rem",
                  alignItems: "center",
                }}
              >
                <FormControl
                  variant="outlined"
                  sx={{
                    minWidth: 120,
                    backgroundColor: theme?.widget?.langBgColor,
                    width: { xs: "100px", md: "120px" },
                    height: "45px",
                    borderRadius: "5px",
                    border: `1px solid ${theme?.widget?.inputBorderColor}`,
                  }}
                >
                  <Select
                    value={defaultLanguage}
                    onChange={handleLanguageChange} // Set the onChange handler here
                    // IconComponent={() => (
                    //     <KeyboardArrowDownIcon
                    //         sx={{ color: "black", mr: 1 }}
                    //     />
                    // )}
                    displayEmpty
                    renderValue={() => (
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={lang}
                          alt={"lang-img"}
                          style={{ width: "40px", marginRight: "10px" }}
                        />
                      </Box>
                    )}
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: 1,
                        //     color: "#9F9F9F",
                        fontSize: "12px",
                      },
                    }}
                  >
                    {languageData?.map((item, index) => (
                      <MenuItem
                        key={item?.idlanguage}
                        value={item?.langcode}
                        sx={{
                          color: "black", // Text color of MenuItem
                          "&.Mui-selected": {
                            backgroundColor: "grey !important", // Highlight selected item
                            color: "#fff",
                          },
                          "&:hover": {
                            backgroundColor: "lightgrey", // Hover effect for MenuItem
                            color: "grey",
                            "&.Mui-selected": {
                              backgroundColor: "darkgray", // Hover effect for MenuItem
                              color: "#fff",
                            },
                          },
                        }}
                      >
                        {(item?.langcode == defaultLanguage?.trim()) != "" ? (
                          <>
                            {item?.language}
                            <CheckBoxIcon
                              sx={{
                                color: theme?.widget?.langCheckboxActive,
                                marginRight: "8px",
                                ml: 2,
                              }}
                            />
                          </>
                        ) : (
                          item?.language
                        )}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {widgetConfig?.settings?.floatButtonActive && (
                  <IconButton
                    aria-label="closeIcon"
                    size="large"
                    onClick={() => handleClose()}
                    sx={{
                      backgroundColor: theme?.widgetButton?.closeBg,

                      "&:hover": {
                        backgroundColor: theme?.widgetButton?.closeHover,
                      },
                    }}
                  >
                    <CloseIcon
                      sx={{
                        color: theme?.widgetButton?.closeText,
                        "&:hover": {
                          color: theme?.widgetButton?.textcloseTextHover,
                        },
                      }}
                    />
                  </IconButton>
                )}
              </Box>
            )}
          </Box>

          {/* Year & Month Navigation */}
          <Box
            sx={{
              display: "flex",
              justifyContent: showMoreMonths ? "space-around" : "center",
              alignItems: "center",
              marginBottom: 2,
            }}
          >
            <IconButton
              aria-label="back"
              onClick={handlePreviousMonth}
              disabled={
                selectedYear < currentYear ||
                (selectedYear === currentYear && selectedMonth === currentMonth)
              }
            >
              <ArrowBack color={theme?.openingHours?.arrowLeftColor} />
            </IconButton>
            <Typography
              variant="h6"
              sx={{
                margin: "0 16px",
                color: theme?.openingHours?.headerTextColor,
              }}
            >
              {selectedYear}
            </Typography>

            <IconButton
              aria-label="forward"
              onClick={handleNextMonth}
              disabled={isForwardButtonDisabled}
            >
              <ArrowForward
                color={
                  isForwardButtonDisabled
                    ? "disabled"
                    : theme?.openingHours?.arrowRightColor
                }
              />
            </IconButton>
          </Box>

          {/* Calendar View */}
          <Grid container spacing={2} mt={2}>
            {monthsToShow.map(({ month, year }, idx) => (
              <Grid item xs={12} sm={6} md={4} key={idx}>
                {renderCalendar(month, year)}
              </Grid>
            ))}
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

export default OpeningHours;
